import { Component, HostBinding, ViewChild, ViewEncapsulation } from '@angular/core';

export enum NotificationYPosition {
  top,
  bottom,
}

export enum NotificationXPosition {
  left,
  right,
}

export enum NotificationLevel {
  default,
  success,
  warn,
  error,
}

export interface NotificationTicket {
  resolve: boolean;
  reject: boolean;
}

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationsComponent {
  @HostBinding('class.notifications-component') isNotificationsComponent = true;
  @HostBinding('class.-top-y') get isTopY(): boolean {
    return this.yPosition === NotificationYPosition.top;
  }
  @HostBinding('class.-bottom-y') get isBottomY(): boolean {
    return this.yPosition === NotificationYPosition.bottom;
  }
  @HostBinding('class.-left-x') get isLeftX(): boolean {
    return this.xPosition === NotificationXPosition.left;
  }
  @HostBinding('class.-right-x') get isRightX(): boolean {
    return this.xPosition === NotificationXPosition.right;
  }

  public level = NotificationLevel.default;
  public ticket: NotificationTicket = {} as NotificationTicket;
  public lifetime: any;
  public lifetimeTicket: any;
  public isDismissible: boolean = true;
  public yPosition = NotificationYPosition.bottom;
  public xPosition = NotificationXPosition.right;

  constructor() {}

  initialize(data: TicketNotification) {
    this.ticket = data.ticket;
    this.lifetime = data.lifetime;
    this.isDismissible = data.isDismissible;
    this.yPosition = data.yPosition;
    this.xPosition = data.xPosition;
    this.refreshLifetimeTicket(data.lifetime);
  }
  close() {
    this.ticket.reject = true;
  }

  private refreshLifetimeTicket(lifetime: number = this.lifetime) {
    this.clearLifetimeTicket();

    if (lifetime > 0) {
      this.lifetimeTicket = setTimeout(() => {}, lifetime);
    }
  }

  private clearLifetimeTicket() {
    if (this.lifetimeTicket) {
      clearTimeout(this.lifetimeTicket);
    }
  }
}

@Component({
  selector: 'app-notification-base',
  template: '',
})
export class NotificationsBaseComponent extends NotificationsComponent {
  @ViewChild('notification', ) notification: NotificationsComponent = new NotificationsComponent();

  public model: any;

  constructor() {
    super();
  }

  initialize(data: TicketNotification) {
    this.model = data.model;
    this.notification.initialize(data);
    super.initialize(data);
  }
}

export interface TicketNotification {
  model: any | null;
  ticket: any;
  lifetime: number | 0;
  isDismissible: boolean | true;
  yPosition: NotificationYPosition | NotificationYPosition.bottom;
  xPosition: NotificationXPosition | NotificationXPosition.right;
}
